import{post } from '@/utils/request';
import{filerequesturl } from '@/utils/baseUrl';


export async function getMDSysMessage(param) {
    return post('/masterData/getMDSysMessage',param,true)
}
/*export const filerequest_url=filerequesturl;
export async function getEditMessage(param) {
    return post('/masterData/getEditMessage',param,true)
}
export async function replaceMasterData(param) {
    return post('/masterData/replaceMasterData',param,true)
}
export async function saveMDRelation(param) {
    return post('/masterData/saveMDRelation',param,true)
}*/
export async function getMDataDetails(param) {
    return post('/masterData/getMDataDetails',param,true)
}
export async function delMDRelation(param) {
    return post('/masterData/delMDRelation',param,true)
}
export async function updateMDMessage(param) {
    return post('/masterData/updateMDMessage',param,true)
}